import { useAppSelector } from '../redux';

export const useIsUserAuth = () =>
  useAppSelector((state) => !!(state.auth.accessToken && state.auth.userId));
